module.exports = __webpack_public_path__ + "img/urbacon_logo.03d18685.svg";